import { config } from '@services/context';
import { PermissionsEnum, User } from '@protos/user';

export const checkIsFreemiumUser = (user: User | undefined) => {
  return user?.permissions?.includes(PermissionsEnum.FREEMIUM);
};

export const checkIsABNUser = (user: User | undefined) => {
  return user?.permissions?.includes(PermissionsEnum.ONYX_USER) || user?.permissions?.includes(PermissionsEnum.AXIS);
};

export const checkIsPremiumUser = (user: User | undefined) => {
  return !checkIsFreemiumUser(user) && user?.permissions?.length && user.permissions.length > 0;
};

export const checkIsInternalUser = (user: User | undefined) => {
  return user?.permissions?.includes(PermissionsEnum.ONYX_USER);
};

export const checkIsAdminUser = (user: User | undefined) => {
  return user?.permissions?.includes(PermissionsEnum.USER_ADMIN);
};

export const checkIsAdminReadOnlyUser = (user: User | undefined) => {
  return user?.permissions?.includes(PermissionsEnum.USER_ADMIN_RO);
};

export const checkIsDTUser = (user: User | undefined) => {
  return user?.permissions?.includes(PermissionsEnum.USER_DT);
};

export const checkIsFluxAdminUser = (user: User | undefined) => {
  return user?.permissions?.includes(PermissionsEnum.FLUX_ADMIN);
};

// Deliberately narrower than DataAdminDep, which also admits FLUX_SNR_ENG_ADMIN and the
// superuser account - both keep API access without the outliers UI, as they did before.
export const checkIsOutliersAdmin = (user: User | undefined): boolean => {
  return !!(checkIsFluxAdminUser(user) || user?.permissions?.includes(PermissionsEnum.DATA_ADMIN));
};

// Flux 3.0 is retired: only these admins keep access, everyone else is sent to Flux 4.0.
// The list lives inside the function because a circular import leaves PermissionsEnum undefined at module load.
export const checkHasLegacyAppAccess = (user: User | undefined): boolean => {
  const legacyAppAccessPermissions = [
    PermissionsEnum.FLUX_ADMIN,
    PermissionsEnum.USER_ADMIN,
    PermissionsEnum.USER_ADMIN_RO,
    PermissionsEnum.TRADING_ADMIN,
    PermissionsEnum.DATA_ADMIN,
  ];

  return !!user?.permissions?.some(permission => legacyAppAccessPermissions.includes(permission));
};

export const checkIsTradingAdminUser = (user: User | undefined) => {
  return user?.permissions?.includes(PermissionsEnum.TRADING_ADMIN);
};

export const checkIsLadderUser = (user: User | undefined) => {
  return user?.permissions?.includes(PermissionsEnum.LADDER);
};

export const checkIsTradingUser = (user: User | undefined) => {
  return user?.permissions?.includes(PermissionsEnum.TRADING);
};

export const checkIsLimitOrderTypesAllowed = (user: User | undefined) => {
  return config.isDev || config.isUAT || user?.permissions?.includes(PermissionsEnum.ONYX_USER) || user?.permissions?.includes(PermissionsEnum.AXIS);
};
